import {SET_CURR_POSITION, SET_SITE_CONFIG} from './mutation-types'

export default {
  //设置全局配置
  [SET_SITE_CONFIG](state, config) {
    state.config = config
  },
  [SET_CURR_POSITION](state, column) {
    state.curr_position = column
  }
}
